import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function EbookDetails() {
  const ebooks = [{
    icon: '📘',
    title: 'eBook 1 — Mecánica General del Scooter Eléctrico',
    subtitle: 'Base Técnica · Componentes · Diagnóstico mecánico',
    desc: 'Entendé cómo está hecho tu scooter de verdad: deck, mástil, plegado, dirección, ruedas, frenos, suspensión y rodamientos. Aprendé a detectar holguras, ruidos y desgastes antes de que se conviertan en fallas caras.',
    color: 'border-blue-500/30',
    bg: 'bg-blue-500/5',
    features: ['Anatomía completa explicada en lenguaje simple', 'Tablas de diagnóstico: ruido → causa → solución', 'Checklist pre-salida / semanal / mensual', 'Sección especial scooters 60–72V alta potencia', 'Errores más comunes del usuario y cómo evitarlos', '100% adaptado a condiciones Argentina/LatAm']
  }, {
    icon: '📗',
    title: 'eBook 2 — Desarme General por Módulos',
    subtitle: 'Método universal · Sin romper nada · Con checklist',
    desc: 'El método paso a paso para abrir, desconectar, cambiar rueda/neumático/frenos y rearmar sin inventar, sin perder tornillos y sin crear fallas nuevas. Incluye orden de trabajo, etiquetado de cables y prueba final.',
    color: 'border-brand/30',
    bg: 'bg-brand/5',
    features: ['Método universal por módulos (A → E)', 'Cambio de cámara/cubierta sin pellizcos', 'Ajuste de frenos mecánicos e hidráulicos', 'Apertura segura del deck (cuándo y cómo)', 'Plantillas imprimibles de registro', 'Sección especial: desarme en scooters 60–72V']
  }, {
    icon: '📙',
    title: 'eBook 3 — Fallas Clásicas + Reparación + Mantenimiento Preventivo',
    subtitle: 'Diagnóstico por síntomas · Sin adivinar · Soluciones seguras',
    desc: 'Las 10 fallas más comunes con su diagnóstico, prueba simple y solución segura. Más un calendario de mantenimiento preventivo realista para que tu scooter dure el doble.',
    color: 'border-orange-500/30',
    bg: 'bg-orange-500/5',
    features: ['Metodología: síntoma → causa → prueba → solución', '"No enciende", "no carga", "tironea", "se apaga", "vibra" y más', 'Tabla completa de síntomas con soluciones paso a paso', 'Calendario de mantenimiento preventivo', 'Hábitos de batería que duplican su vida útil', 'Sección especial: fallas en alta potencia 60–72V']
  }];
  return <section className="py-16 px-4" data-id="element-66">
      <div className="max-w-5xl mx-auto" data-id="element-67">
        <div className="text-center mb-16" data-id="element-68">
          <h2 className="text-3xl font-heading font-bold text-white mb-2" data-id="element-69">
            📚 3 eBOOKS COMPLETOS
          </h2>
          <p className="text-muted" data-id="element-70">
            Cada eBook incluye explicaciones claras, imágenes y checklists.
          </p>
        </div>

        <div className="space-y-8" data-id="element-71">
          {ebooks.map((ebook, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className={`bg-surface border ${ebook.color} ${ebook.bg} rounded-2xl p-6 md:p-10`} data-id="element-72">
              <div className="flex flex-col md:flex-row gap-8" data-id="element-73">
                <div className="md:w-1/3" data-id="element-74">
                  <div className="text-6xl mb-4" data-id="element-75">{ebook.icon}</div>
                  <h3 className="text-2xl font-heading font-bold text-white mb-2" data-id="element-76">
                    {ebook.title}
                  </h3>
                  <div className="text-brand font-medium mb-4" data-id="element-77">
                    {ebook.subtitle}
                  </div>
                  <p className="text-gray-300 leading-relaxed" data-id="element-78">{ebook.desc}</p>
                </div>
                <div className="md:w-2/3 bg-background/50 rounded-xl p-6 border border-border" data-id="element-79">
                  <h4 className="font-bold text-white mb-4" data-id="element-80">
                    Cada eBook incluye:
                  </h4>
                  <ul className="space-y-3" data-id="element-81">
                    {ebook.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-3" data-id="element-82">
                        <CheckCircle2 className="text-brand shrink-0 mt-0.5" size={20} data-id="element-83" />
                        <span className="text-gray-300" data-id="element-84">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}